/* tokamoka — Karakter hero: ruh hali seçimi, otomatik geçiş, renk seçimi, masaüstünde fareyle derinlik ve ölçüm.
   Sepete ekleme temanın <product-form> öğesiyle yapılır (çekmece açılır); satırda gizli _tk_kaynak = hero vardır.
   Dekupe maskesi (CSS değişkenleri) renk değişince güncellenir; bkz. snippets/tk-cut.liquid. */
(function () {
  'use strict';

  function $(sel, el) { return (el || document).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function money(cents) {
    var n = Math.round(cents) / 100;
    return n.toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + '₺';
  }
  var CUT_VARS = ['--tk-cut', '--tk-l', '--tk-fx', '--tk-fy', '--tk-fyh', '--tk-ox', '--tk-oy'];
  function applyCut(fig, cut) {
    CUT_VARS.forEach(function (k) { fig.style.removeProperty(k); });
    (cut || '').split(';').forEach(function (d) {
      var c = d.indexOf(':');
      if (c > 0) fig.style.setProperty(d.slice(0, c).trim(), d.slice(c + 1).trim());
    });
    fig.classList.toggle('has-cut', !!cut);
  }
  function cutUrl(cut) {
    var m = /url\(([^)]+)\)/.exec(cut || '');
    return m ? m[1].replace(/^['"]|['"]$/g, '') : '';
  }
  function mark(action, detail) {
    if (window.tkBundle && typeof window.tkBundle.markHero === 'function') window.tkBundle.markHero(action, detail);
  }

  function init(root) {
    if (!root || root.__tkKh) return;
    root.__tkKh = true;
    var chips = $$('[data-tk-kh-chip]', root);
    var figs = $$('[data-tk-kh-fig]', root);
    var panels = $$('[data-tk-kh-panel]', root);
    var bars = $$('.tk-kh__bar', root);
    var orbs = $$('[data-tk-kh-orb]', root);
    var n = chips.length;
    if (!n) return;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 3800;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, timer = null, held = !!reduce, hover = false, inView = true;

    function place() {
      orbs.forEach(function (o) {
        var k = parseInt(o.getAttribute('data-tk-kh-orb'), 10);
        if (k === i) {
          o.classList.add('is-hidden');
          o.tabIndex = -1;
          o.setAttribute('aria-hidden', 'true');
          o.style.left = '50%';
          o.style.top = '50%';
          return;
        }
        var slot = (k - i - 1 + n) % n;
        var a = (-90 + 360 * (slot + 0.5) / Math.max(n - 1, 1)) * Math.PI / 180;
        o.style.left = (50 + 41.5 * Math.cos(a)).toFixed(2) + '%';
        o.style.top = (50 + 41.5 * Math.sin(a)).toFixed(2) + '%';
        o.classList.remove('is-hidden');
        o.tabIndex = 0;
        o.removeAttribute('aria-hidden');
      });
    }

    function bars_() {
      bars.forEach(function (b, k) {
        b.classList.remove('is-running');
        b.classList.toggle('is-done', k < i || (k === i && held));
      });
      if (!held && bars[i]) {
        void bars[i].offsetWidth;
        bars[i].style.setProperty('--tk-kh-dur', interval + 'ms');
        bars[i].classList.add('is-running');
      }
    }

    function show(next, smooth) {
      i = (next + n) % n;
      chips.forEach(function (c, k) { c.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      figs.forEach(function (f, k) {
        if (k === i) f.classList.remove('is-pending');
        f.classList.toggle('is-active', k === i);
      });
      panels.forEach(function (p, k) {
        p.classList.toggle('is-active', k === i);
        if (k === i) p.removeAttribute('aria-hidden'); else p.setAttribute('aria-hidden', 'true');
      });
      bars_();
      place();
      var chip = chips[i];
      var row = chip && chip.parentNode;
      if (row && row.scrollWidth > row.clientWidth + 2) {
        var left = chip.offsetLeft - (row.clientWidth - chip.offsetWidth) / 2;
        try { row.scrollTo({ left: Math.max(0, left), behavior: smooth ? 'smooth' : 'auto' }); } catch (e) { row.scrollLeft = left; }
      }
    }

    function stop() { if (timer) { clearTimeout(timer); timer = null; } }
    function schedule() {
      stop();
      if (held || hover || !inView || document.hidden) {
        bars.forEach(function (b) { b.classList.remove('is-running'); });
        return;
      }
      bars_();
      timer = setTimeout(function () { show(i + 1, true); schedule(); }, interval);
    }
    function hold() {
      held = true;
      stop();
      bars_();
    }

    chips.forEach(function (c, k) {
      c.addEventListener('click', function () {
        hold();
        show(k, true);
        mark('secim', c.textContent.trim());
      });
    });
    orbs.forEach(function (o) {
      o.addEventListener('click', function () {
        hold();
        show(parseInt(o.getAttribute('data-tk-kh-orb'), 10), true);
        mark('secim', o.getAttribute('aria-label') || '');
      });
    });

    panels.forEach(function (p, k) {
      var form = $('form', p);
      var idInput = form && $('input[name="id"]', form);
      var priceEl = $('[data-tk-kh-price]', p);
      var fig = figs[k];
      var img = fig && $('.tk-kh__img', fig);
      var simg = fig && $('.tk-kh__simg', fig);
      var vars = $$('[data-tk-kh-var]', p);
      vars.forEach(function (btn) {
        btn.addEventListener('click', function () {
          hold();
          vars.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          if (idInput) idInput.value = btn.getAttribute('data-id');
          if (priceEl) priceEl.textContent = money(parseInt(btn.getAttribute('data-price'), 10) || 0);
          if (img && btn.getAttribute('data-src')) {
            img.setAttribute('srcset', btn.getAttribute('data-srcset') || '');
            img.setAttribute('src', btn.getAttribute('data-src'));
            if (simg) {
              simg.setAttribute('srcset', btn.getAttribute('data-srcset') || '');
              simg.setAttribute('src', btn.getAttribute('data-src'));
            }
            applyCut(fig, btn.getAttribute('data-cut') || '');
            fig.classList.remove('is-active');
            void fig.offsetWidth;
            fig.classList.add('is-active');
          }
          mark('renk', btn.textContent.trim());
        });
      });
      if (form) form.addEventListener('submit', function () { hold(); mark('sepete-ekle', ''); });
    });
    $$('.tk-kh__pname', root).forEach(function (a) { a.addEventListener('click', function () { mark('detay', ''); }); });
    $$('.tk-kh__all', root).forEach(function (a) { a.addEventListener('click', function () { mark('tum-tokalar', ''); }); });

    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      root.addEventListener('mouseenter', function () { hover = true; schedule(); });
      root.addEventListener('mouseleave', function () { hover = false; schedule(); });
    }
    root.addEventListener('focusin', function () { hover = true; schedule(); });
    root.addEventListener('focusout', function () { hover = false; schedule(); });
    document.addEventListener('visibilitychange', schedule);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var vis = entries[0].isIntersecting;
        if (vis !== inView) { inView = vis; schedule(); }
      }, { threshold: 0.25 }).observe(root);
    }

    function warm() {
      figs.forEach(function (f) { f.classList.remove('is-pending'); });
      $$('[data-tk-kh-var]', root).forEach(function (b) {
        var u = cutUrl(b.getAttribute('data-cut'));
        if (u) { var im = new Image(); im.src = u; }
      });
    }

    var stage = $('[data-tk-kh-stage]', root);
    if (stage && !reduce && window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var raf = 0, tx = 0, ty = 0;
      var paint = function () {
        raf = 0;
        stage.style.setProperty('--tk-px', tx.toFixed(3));
        stage.style.setProperty('--tk-py', ty.toFixed(3));
      };
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        if (!r.width) return;
        tx = Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width) * 2 - 1));
        ty = Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height) * 2 - 1));
        if (!raf) raf = requestAnimationFrame(paint);
      });
      stage.addEventListener('pointerleave', function () { tx = 0; ty = 0; if (!raf) raf = requestAnimationFrame(paint); });
    }
    if (document.readyState === 'complete') setTimeout(warm, 400);
    else window.addEventListener('load', function () { setTimeout(warm, 400); });

    show(0, false);
    schedule();
  }

  $$('[data-tk-kh]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) { $$('[data-tk-kh]', e.target).forEach(init); });
})();
